var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPause = function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5.5a1 1 0 0 0-2 0v5a1 1 0 1 0 2 0v-5Zm4 0a1 1 0 1 0-2 0v5a1 1 0 1 0 2 0v-5Z",
    fill: "#fff"
  })));
};
export { SvgPause as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8Y2lyY2xlIGN4PSI4IiBjeT0iOCIgcj0iOCIgZmlsbD0iY3VycmVudENvbG9yIi8+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcgNS41QzcgNC45NDc3MiA2LjU1MjI4IDQuNSA2IDQuNUM1LjQ0NzcyIDQuNSA1IDQuOTQ3NzIgNSA1LjVWMTAuNUM1IDExLjA1MjMgNS40NDc3MiAxMS41IDYgMTEuNUM2LjU1MjI4IDExLjUgNyAxMS4wNTIzIDcgMTAuNVY1LjVaTTExIDUuNUMxMSA0Ljk0NzcyIDEwLjU1MjMgNC41IDEwIDQuNUM5LjQ0NzcyIDQuNSA5IDQuOTQ3NzIgOSA1LjVWMTAuNUM5IDExLjA1MjMgOS40NDc3MiAxMS41IDEwIDExLjVDMTAuNTUyMyAxMS41IDExIDExLjA1MjMgMTEgMTAuNVY1LjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";